module.exports = __webpack_public_path__ + "media/images/athletes/2113-97a701b80b6d7a23768d8a9915efad4e.png";